import { IConversion, IPerformancePagination } from '@/models/performance';
import APIService from '.';

export default class PerformanceConversionsService extends APIService {
  getConversions(resource: string, params: Record<string, any> = {}) {
    return this.get<IPerformancePagination<IConversion>>(resource, {
      params
    });
  }

  getOverview(filters: any, locations: { id: string }[]) {
    return this.get(
      `/v3/admin/business/redemptions/overview${
        locations.length
          ? `?${locations.map(item => `locationIds=${item.id}`).join('&')}`
          : ''
      }`,
      {
        params: filters
      }
    );
  }

  getGraph(filters: any, locations: { id: string }[]) {
    return this.get(
      `/v3/admin/business/redemptions/graphs${
        locations.length
          ? `?${locations.map(item => `locationIds=${item.id}`).join('&')}`
          : ''
      }`,
      {
        params: filters
      }
    );
  }
}
